<div class="flex items-center gap-2 mb-3">
  <h3 class="m-0 text-base font-bold text-midnight flex-grow">Signers</h3>
  @if (!isFinalized && !noSigners) {
  <button
    class="btn btn-xs btn-outline normal-case rounded-full"
    (click)="onAddSigner()"
  >
    Add signer
  </button>
  }
</div>

@if (noSigners && !isLoading) {
<div class="flex flex-col items-center justify-center gap-4 min-h-[120px]">
  <p class="m-0 text-sm text-light">No signers added yet</p>
  <button
    class="btn btn-xs btn-primary normal-case rounded-full flex items-center gap-2"
    (click)="onAddSigner()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>
    <span>Add signer</span>
  </button>
</div>
} @else if (isLoading) {
<div class="flex flex-col items-center justify-center gap-4 min-h-[120px]">
  <et-atoms-spinner size="large"></et-atoms-spinner>
</div>
} @else {
<div class="flex flex-col gap-4">
  <ng-content></ng-content>
</div>
}
